export const LOAD_COMPLETE_FAVICON = "app/assets/img/blue_check.png";
